import { render, staticRenderFns } from "./SetupProgressWidget.vue?vue&type=template&id=6f8efc8a&scoped=true"
import script from "./SetupProgressWidget.vue?vue&type=script&lang=js"
export * from "./SetupProgressWidget.vue?vue&type=script&lang=js"
import style0 from "./SetupProgressWidget.vue?vue&type=style&index=0&id=6f8efc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8efc8a",
  null
  
)

export default component.exports